module.exports = __webpack_public_path__ + "static/media/ruler-icon.bf4b5b7c.svg";